export const NAME = 'bibliographies';
export const LEVEL_ONE = 'BibliographiesComponentReducer';
